// Tiny in-memory cache: a track's playback src (the Apple preview URL, which
// becomes the player's musicSrc) → its Apple Music catalog deep link (page_url).
//
// Populated centrally in resolveTrackSrc so every play surface that routes
// through it is covered without threading pageUrl through each addTrack call.
// Read by NowPlayingPage for the "Listen on Apple Music" deep link (with an
// Apple Music *search* fallback when a track has no stored page_url).
const cache = new Map();

export function rememberApplePageUrl(src, pageUrl) {
    if (src && pageUrl) cache.set(src, pageUrl);
}

export function getApplePageUrl(src) {
    return src ? (cache.get(src) || null) : null;
}
